import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fadeVariants,
  slideVariants,
  bounce_right_to_left_variants,
  staticBounceVariants
} from "shared/components/animations";

const GuesserGuessing = ({
  asker,
  onBack,
  answers,
  onConfirm,
  mobile_app,
  toggleModal,
  ttl_guesser,
  onAnswerClick,
  guessing_params
}) => {
  const guess_text = _.get(guessing_params, "guess_text", "Guess the Lie for:");
  const confirm_text = _.get(
    guessing_params,
    "confirm_text",
    "Confirm your guess?"
  );
  const go_back_button = _.get(guessing_params, "go_back_button", "Go back");
  const yes_button = _.get(guessing_params, "yes_button", "Yes!");
  const bottom_text = _.get(
    guessing_params,
    "bottom_text",
    "Hang on, we’ll show you the correct answer in a sec!"
  );
  const choose_text = _.get(guessing_params, "choose_text", "Choose quickly!");
  const modal_button_text = _.get(
    guessing_params,
    "modal_button_text",
    "My Two Truths and a Lie"
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`ttl-guessing ${mobile_app ? "mobile-cnt" : "web-cnt"}`}
    >
      <div className="guessing-first">
        <motion.h2 variants={fadeVariants} className="ttl-primary-text">
          {guess_text}
        </motion.h2>
        <motion.img
          variants={bounce_right_to_left_variants}
          alt=""
          className="ttl-user-profile"
          src={asker.profile_image}
        />
        <motion.p
          variants={bounce_right_to_left_variants}
          className="ttl-user-name"
        >
          {asker.display_name}
        </motion.p>
        {!ttl_guesser.clicked &&
          !ttl_guesser.confirmed &&
          answers?.map((value, index) => (
            <motion.button
              variants={bounce_right_to_left_variants}
              className="ttl-option-yellow"
              onClick={() => onAnswerClick(index)}
            >
              {`${index === 0 ? "A" : index === 1 ? "B" : "C"}) ${value}`}
            </motion.button>
          ))}
        {ttl_guesser.clicked && !ttl_guesser.confirmed && (
          <div className="guessing-confirm">
            <h2 className="ttl-primary-text">{confirm_text}</h2>
            <motion.h1
              variants={staticBounceVariants}
              className="ttl-confirm-text"
            >
              {answers[ttl_guesser.guessed]}
            </motion.h1>
            <motion.div
              variants={staticBounceVariants}
              className="ttl-button-container"
            >
              <button onClick={onBack} className="go-back-button">
                {go_back_button}
              </button>
              <button onClick={onConfirm} className="yes-button">
                {yes_button}
              </button>
            </motion.div>
          </div>
        )}
        {ttl_guesser.clicked &&
          ttl_guesser.confirmed &&
          answers?.map((value, index) => (
            <motion.button
              variants={bounce_right_to_left_variants}
              onClick={() => onAnswerClick(index)}
              disabled={ttl_guesser.clicked && ttl_guesser.confirmed}
              className={`${
                ttl_guesser.guessed === index
                  ? "ttl-option-green"
                  : "ttl-option-faded"
              }`}
            >
              {`${index === 0 ? "A" : index === 1 ? "B" : "C"}) ${value}`}
            </motion.button>
          ))}
      </div>
      <motion.h2 variants={fadeVariants} className="ttl-primary-text">
        {ttl_guesser.clicked && ttl_guesser.confirmed
          ? bottom_text
          : choose_text}
      </motion.h2>
      <motion.div variants={slideVariants} className="bottom-modal">
        <div
          className={`ttl-modal-bottom-container ${
            mobile_app ? "mobile-cnt" : "web-cnt"
          }`}
        >
          <button onClick={toggleModal} className="modal-button">
            {modal_button_text}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default GuesserGuessing;
